import React from 'react';

const Footer = () => (
  <footer>
    <p className="footer-text">Project by Simon Wathigo @2020</p>
  </footer>
);

export default Footer;
